import { useCallback } from 'react';
import LoadingPageService from './service';
import { useRequest } from '../utils/customHooks';

export const useFetchSignupActivation = (uuid, signupType) => {
    const LoadingPageAPI = new LoadingPageService();
    const activateFn = signupType === 'partner'
        ? LoadingPageAPI.activatePartnerAccount
        : signupType === 'agency'
            ? LoadingPageAPI.activateAgencyAccount
            : LoadingPageAPI.activateAccount;
    return useRequest(
        useCallback(activateFn, []),
        () => {
            return true;
        },
        () => {},
        uuid
    );
};
